import { transformBankAccountDetails } from '../../common/utils/bankingUtils';
import { requestBuilder } from '../../http/RequestBuilder';
import type { AccountDetail } from '../types/BankAccount';

const useGetBankAccountDetailsV2 = requestBuilder.query<
    AccountDetail,
    { bankAccountId: string }
>({
    endpoint: ({ bankAccountId }) =>
        `/api/bank-accounts/${bankAccountId}/details`,
    queryKey: ({ bankAccountId }) => `getAccountDetailsV2/${bankAccountId}`,
});

const useGetBankAccountDetails = (bankAccountId: string, enabled = true) => {
    const { status, data, isLoading, refetch, isRefetching } =
        useGetBankAccountDetailsV2({ bankAccountId }, { enabled });

    const errorFetching = status === 'error';

    const accountDetails =
        data != null ? transformBankAccountDetails(data) : null;

    return {
        isLoading: isLoading || isRefetching,
        errorFetching,
        refetch,
        accountDetails,
    };
};

export default useGetBankAccountDetails;
